import React from "react";
import { Row, Col } from "antd";
import styles from "./BidToolConfigurationView.module.scss";
import BidToolConfigurationView from ".";
import InputField from "../../reusable-components/TNInputField";
import { InputfieldTypes } from "../../enums/InputFieldAttributesEnums";
import clsx from "clsx";
interface BidtoolContainerProps {
  headerTitles: string[];
  small?: boolean;
  children?: React.ReactNode;
  containerOne?: boolean;
}
const BidToolConfigContainer = ({
  headerTitles,
  containerOne,
  small,
  children,
}: BidtoolContainerProps) => {
  return (
    <div
      className={clsx({
        [styles.BidtoolContainer]: !small,
        [styles.BidtoolContainersmall]: small,
      })}
    >
      <div
        className={clsx({
          [styles.BidtoolHeader]: !small,
          [styles.BidtoolHeaderSmall]: small,
          [styles.BidtoolHeaderContainerOne]: containerOne && !small,
        })}
      >
        <Row>
          {headerTitles.map((title, index) => (
            <Col span={24 / headerTitles?.length}>
              {index !== 0 ? (
                <div className={styles.secondCol}>{title}</div>
              ) : (
                <div className={styles.firstCol}>{title}</div>
              )}
            </Col>
          ))}
        </Row>
      </div>
      <div
        className={clsx({
          [styles.BidToolContainerContent]: !small,
          [styles.BidToolContainerContentSmall]: small,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default BidToolConfigContainer;
